import { Routes } from '@angular/router';
import { RequestMapperService } from './services/request-mapper.service';
import { environment } from '../environments/environment';
import { PublicResultViewComponent } from './result/public-result-view/public-result-view.component';

/**
 * Platform-aware routing configuration
 * - Web builds: Default to HomeComponent
 * - Android builds: Default to AuthenticationModule
 * 
 * IMPORTANT: Route order matters!
 * 1. Specific routes (home, auth, static pages) come first
 * 2. Empty path with children (BASE_RELATIVE_URL) comes last
 * 3. The empty path route will handle the root redirect internally
 */
export const routes: Routes = [
  // ✅ Home route - ONLY for web builds (excluded from Android)
  ...(environment.isAndroid ? [] : [{
    path: RequestMapperService.HOME_URL, // 'home'
    loadComponent: () =>
      import('./home/home.component').then((c) => c.HomeComponent),
  }]),
  // Authentication module (all platforms)
  {
    path: RequestMapperService.AUTH_URL, // 'auth'
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  
  // Static pages (all platforms)
  {
    path: 'result/view/:userExamId',
    loadComponent: ()=> import('./result/public-result-view/public-result-view.component').then(
      (c)=> c.PublicResultViewComponent
    ),
    data: { breadcrumb: 'View Result' }
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./privacy-policy/privacy-policy.component').then(
        (c) => c.PrivacyPolicyComponent
      ),
  },
  {
    path: 'terms-of-use',
    loadComponent: () =>
      import('./terms-of-use/terms-of-use.component').then(
        (c) => c.TermsOfUseComponent
      ),
  },
  
  // ✅ Root path redirect - Platform-aware
  {
    path: '',
    pathMatch: 'full',
    redirectTo: environment.isAndroid 
      ? RequestMapperService.AUTH_URL  // Android: → 'auth'
      : RequestMapperService.HOME_URL, // Web: → 'home'
  },
  
  // Base module with protected routes (empty path with children)
  // This catches all routes that start with '' (everything else)
  // Must come AFTER the root redirect
  {
    path: RequestMapperService.BASE_RELATIVE_URL, // '' (empty)
    loadChildren: () =>
      import('./base/base.module').then((m) => m.BaseModule),
  },
];